export default "__VITE_ASSET__d53f63a1__$_?component__"